export const isPhoneDevice = navigator =>
  /Mobi|Android|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  )

export const isTabletDevice = navigator =>
  /Tablet|iPad|PlayBook|Nexus 7/i.test(navigator.userAgent)

export const isDesktopDevice = navigator =>
  !isPhoneDevice(navigator) && !isTabletDevice(navigator)
